import axios from "axios";
import React, { useEffect } from "react";
import { baseUrl } from "../../config/baseUrl";
import JobScheduleListTable from "./jobschedule-list-table";

export const JobScheduleView = () => {

  return <div>
    <JobScheduleListTable />
  </div>;
};
